import React from 'react';
import { useEmbedFilters } from './EmbedWrapper';
import { useTeamMembersData } from '../../hooks/useEmbedData';
import { TeamMembersWidget } from '../widgets/TeamMembersWidget';

const EmbedTeamMembers: React.FC = () => {
  const filters = useEmbedFilters();
  const { data, isLoading, error } = useTeamMembersData(filters);

  if (error) {
    return <div className="text-red-600 text-center py-4">Error: {error}</div>;
  }

  return <TeamMembersWidget employees={data} isLoading={isLoading} />;
};

export default EmbedTeamMembers;
